import { useEffect } from "react";

import { useBranding } from "@/api/hooks/tenant";
import { applyBranding } from "@/lib/branding";

/** Keeps the document's colors, tab icon and title suffix in line with this host's branding. */
export function BrandingSync() {
  const branding = useBranding();
  useEffect(() => applyBranding(branding), [branding]);
  return null;
}
